import { call, put, takeLatest } from 'redux-saga/effects';
import {
    REQUEST_PRACTITIONERS,
    SEARCH_REQUEST_PRACTITIONERS,
    REQUEST_PROFIL_PRACTITIONER,
    REQUEST_PROFIL_PLATFORM_PRACTITIONER,
    REQUEST_FILES_PRACTITIONER,
    ADD_FILE_PRACTITIONER,
    UPDATE_PRACTITIONER,
    SYNCHRONISE_PRACTITIONER,
    loadedFilesPractitioner,
    loadedPractitioners,
    loadedCNIPractitioner,
    loadedSignaturePractitioner,
    updatedPractitioner,
    synchronisedPractitioner
} from '../actions/practitioners.action';

import { Practitioners } from '../api/index';
import { toast } from "react-toastify";

export function* requestListPractitioners() {
    try {
        let practitioners = yield call(() => Practitioners.all());
        yield put(loadedPractitioners(practitioners.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* searchPractitioners(payload) {
    try {
        let practitioners = null;
        if (payload.data.search.length > 0) {
            practitioners =yield call(() => Practitioners.search(payload.data.search));
        } else {
            practitioners = yield call(() => Practitioners.all());
        }

        yield put(loadedPractitioners(practitioners.data));
    } catch (err) {
        toast.error(err.response.data.message);

    }
}

export function* requestProfilPractitioner({payload}) {
    try {
        let practitioner =yield call(() => Practitioners.profil(payload));
        yield put(loadedPractitioners(practitioner.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* requestProfilPlatformPractitioner({payload}) {
    try {
        let practitioner =yield call(() => Practitioners.profilPlatform(payload));
        yield put(loadedPractitioners(practitioner.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* requestFilesPractitioner({payload}) {
    try {
        let signatureData = yield call(() => Practitioners.getSignature(payload));
        let cniData = yield call(() => Practitioners.getCNI(payload));
        let practitioner = yield call(() => Practitioners.profil(payload));

        let response = {
            signature: signatureData.data,
            cni: cniData.data
        };
        yield put(loadedFilesPractitioner(response));
        yield put(loadedPractitioners(practitioner.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* addFilePractitioner(payload) {
    if (payload.data.get("type") === "cni") {
        try {
            let cni = yield call(() => Practitioners.setCNI({id: payload.data.get("id"), file: payload.data}));
            toast.success('file uploaded');
            yield put(loadedCNIPractitioner(cni.data));
        } catch (err) {
            toast.error("Erreur lors de l'envoi de l'image");
        }
    } else if (payload.data.get("type") === "signature") {
        try {
            let signature = yield call(() => Practitioners.setSignature({id: payload.data.get("id"), file: payload.data}));
            toast.success('file uploaded');
            yield put(loadedSignaturePractitioner(signature.data));
        } catch (err) {
            toast.error("Erreur lors de l'envoi de l'image");
        }
    }
}

export function* updatePractitioner(payload) {
    try {
        yield call(() => Practitioners.update(payload));
        yield put(updatedPractitioner());
        let practitioner = yield call(() => Practitioners.profil(payload.id));
        yield put(loadedPractitioners(practitioner.data));
        toast.success('Profil mis à jour')
    } catch (e) {
        let errors = e.response.data.details;
        for (e of errors) {
            toast.error(e['field'] + ' : ' + e['message']);
        }
    }
}

export function* synchronisePlatformPractitioner(payload) {
    try {
        yield call(() => Practitioners.synchronisePlatform(payload));
        yield put(synchronisedPractitioner());
        toast.success('Compte synchronisé')
    } catch (err) {
        toast.error(err.response.data.message);
    }
}


export function* watchRequestListPractitioners() {
    yield takeLatest(REQUEST_PRACTITIONERS, requestListPractitioners);
}

export function* watchSearchRequestPractitioners() {
    yield takeLatest(SEARCH_REQUEST_PRACTITIONERS, searchPractitioners)
}

export function* watchRequestProfilPractitioner() {
    yield takeLatest(REQUEST_PROFIL_PRACTITIONER, requestProfilPractitioner);
}

export function* watchRequestProfilPlatformPractitioner() {
    yield takeLatest(REQUEST_PROFIL_PLATFORM_PRACTITIONER, requestProfilPlatformPractitioner);
}

export function* watchRequestFilesPractitioner() {
    yield takeLatest(REQUEST_FILES_PRACTITIONER, requestFilesPractitioner)
}

export function* watchAddFilePractitioner() {
    yield takeLatest(ADD_FILE_PRACTITIONER, addFilePractitioner)
}

export function* watchUpdatePractitioner() {
    yield takeLatest(UPDATE_PRACTITIONER, updatePractitioner)
}

export function* watchSynchronisePlatformPractitioner() {
    yield takeLatest(SYNCHRONISE_PRACTITIONER, synchronisePlatformPractitioner)
}


// WEBPACK FOOTER //
// ./src/sagas/practitioners.saga.js